var _defs, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstallericon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Installer_icon",
    "data-name": "Installer icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_38465",
    x: 13.398,
    y: 6.391,
    width: 35.208,
    height: 28.24,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_38466",
    x: 13.617,
    y: 16.799,
    width: 34.616,
    height: 28.294,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_38467",
    x: 6.139,
    y: 24.52,
    width: 49.726,
    height: 31.09,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_463",
    "data-name": "Ellipse 463",
    cx: 31,
    cy: 31,
    r: 31,
    fill: "#56aa1c"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12594",
    "data-name": "Group 12594",
    transform: "translate(15.139 14.391)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12595",
    "data-name": "Group 12595"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -15.14, -14.39)",
    filter: "url(#Path_38465)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38465-2",
    "data-name": "Path 38465",
    d: "M152.078,7.526c-.1-1.216-1.788-5.538-5.46-6.646v2.98a.382.382,0,0,1-.382.382h0a.382.382,0,0,1-.382-.382V.867a.922.922,0,0,0-.86-.868h-1.028a.925.925,0,0,0-.865.868V3.859a.382.382,0,1,1-.765,0V.9C138.8,2,137.021,6.312,136.915,7.54a1.117,1.117,0,0,0-1.042,1,.944.944,0,0,0,1.03,1.018,42.457,42.457,0,0,0,7.185.682,42.464,42.464,0,0,0,7.988-.682.966.966,0,0,0,.716-.243,1.032,1.032,0,0,0,.29-.775,1.151,1.151,0,0,0-1-1.012",
    transform: "translate(-113.48 14.39)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -15.14, -14.39)",
    filter: "url(#Path_38466)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38466-2",
    "data-name": "Path 38466",
    d: "M148.5,195.751h-.025c-.161,0-.322,0-.485,0l-.38-.006-.185,0-.178-.005q-.418-.013-.824-.034h-.015a36.992,36.992,0,0,1-4.693-.55l-.009,0-.123-.022h0c-.512-.1-1-.2-1.457-.3a1.589,1.589,0,0,0-.112,1.011,1.279,1.279,0,0,0,.93,1.122,14.065,14.065,0,0,0,1.778,3.589c1.1,1.594,3.243,4.707,5.978,4.568,2.409-.123,4.055-2.582,5.434-4.773a15.989,15.989,0,0,0,1.6-3.4,1.359,1.359,0,0,0,.828-1.1,1.615,1.615,0,0,0-.093-.972,37.169,37.169,0,0,1-7.971.889",
    transform: "translate(-117.37 -170.02)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -15.14, -14.39)",
    filter: "url(#Path_38467)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38467-2",
    "data-name": "Path 38467",
    d: "M31.676,344.2a2.6,2.6,0,0,0-.475-1.228,2.681,2.681,0,0,0-1.117-.846c-.99-.439-3.8-1.487-7.625-2.773a7.437,7.437,0,0,1-6.6,4.188,7.437,7.437,0,0,1-6.6-4.188c-3.822,1.286-6.635,2.334-7.625,2.773a2.681,2.681,0,0,0-1.117.846A2.6,2.6,0,0,0,.051,344.2a3.507,3.507,0,0,0-.05.638c.035,2.555,2.908,4.394,4.039,5.124,3.654,2.358,7.989,2.447,10.985,2.476q.413,0,.839.006t.839-.006h.086a.779.779,0,0,0,.09-.076l4.026-4.068a.8.8,0,0,0,.212-.721,2.758,2.758,0,0,1,3.3-3.243c.054.012.075.079-.052.207l-1.384,1.4a.34.34,0,0,0-.071.383,3.438,3.438,0,0,0,1.673,1.65.342.342,0,0,0,.384-.074l1.472-1.487a.071.071,0,0,1,.119.035,2.76,2.76,0,0,1-3.2,3.334.808.808,0,0,0-.725.219l-2.264,2.287a16.225,16.225,0,0,0,7.324-2.318c1.13-.729,4-2.569,4.038-5.124a3.508,3.508,0,0,0-.05-.638",
    transform: "translate(15.14 -306.83)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstallericon);
export default __webpack_public_path__ + "static/media/Installer icon.6136fb122b8a1d10a855b7227168a829.svg";
export { ForwardRef as ReactComponent };